import type { AdminPageAccessRule } from '../../registry.ts';

/** Хто бачить сторінку `calendars`: у перший екран їде лише це (опис і код — у `page.ts`). */
export default {
  group: 'company',
  permission: 'worktime.edit',
} satisfies AdminPageAccessRule;
